/**
 * @generated SignedSource<<f9eef4e592d0218b50b5f16f3a8dbc99>>
 * @relayHash dedf0f2eb63c0045a7fe2f4d9ee6824d
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID dedf0f2eb63c0045a7fe2f4d9ee6824d

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siren"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "siren",
        "variableName": "siren"
      }
    ],
    "concreteType": "UrlResponse",
    "kind": "LinkedField",
    "name": "downloadContractsBySiren",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DownloadContractsBySirenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DownloadContractsBySirenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "dedf0f2eb63c0045a7fe2f4d9ee6824d",
    "metadata": {},
    "name": "DownloadContractsBySirenMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "1694eb06296c8798ccba50a30260f05d";

export default node;
